import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaNewspaper, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaChevronDown, FaChevronUp, FaEdit } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import useVerifInternet from '../administration/verifInternet';
import StatutInternet from '../administration/statutInternet';
import QuestionModal from '../administration/qcm/editeur_qcm';

const Demarrer_examen_refonte = () => {
    useAuth(); // Vérifie l'authentification
    const location = useLocation();
    const enLigne = useVerifInternet();
    const navigate = useNavigate();
    const [isPaused, setIsPaused] = useState(false);

    // États
    const [qcms, setQcms] = useState([]);
    const [langue, setLangue] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const [favorites, setFavorites] = useState(new Set());
    const [currentQcmIndex, setCurrentQcmIndex] = useState(() => {
        const savedIndex = localStorage.getItem("currentQcmIndex");
        return savedIndex !== null ? Number(savedIndex) : 0;
    });

    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
    const user_id = localStorage.getItem('user_id');
    const { examen_id, nbre_heures, statut, type_examen } = location.state || {};

    const isEssai = type_examen === 'Essai';
    
    // États pour le modal de la situation
    const [showSituationModal, setShowSituationModal] = useState(false);
    const [selectedSituation, setSelectedSituation] = useState(null);

    // Fonction pour ouvrir le modal de la situation
    const handleOpenSituation = (situation) => {
        setSelectedSituation(situation);
        setShowSituationModal(true);
    };

    // Fonction pour fermer le modal
    const handleCloseSituationModal = () => {
        setShowSituationModal(false);
        setSelectedSituation(null);
    };

    const { pauseChoice } = location.state || {};
    const [afficherAide, setAfficherAide] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [showPauseModal, setShowPauseModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const handleShowPauseModal = () => setShowPauseModal(true);
    const handleClosePauseModal = () => setShowPauseModal(false);


    const [textColor, setTextColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');
    const [optionColors, setOptionColors] = useState({});
    const [showColorPicker, setShowColorPicker] = useState(false);

    // Gestion du chronomètre
    const heureDebutInitiale = () => {
        if (isEssai) return null;
        const debut = new Date().toISOString();
        localStorage.setItem('heureDebutExamen', debut);
        return debut;
    };

    const [heureDebut, setHeureDebut] = useState(() => {
        return localStorage.getItem('heureDebutExamen') || heureDebutInitiale();
    });

    const heureFinInitiale = () => {
        if (isEssai) return null;
        const fin = new Date();
        fin.setSeconds(fin.getSeconds() + nbre_heures * 3600);
        return fin.getTime();
    };

    const [heureFin, setHeureFin] = useState(() => {
        const stored = localStorage.getItem('heureFinExamen');
        return stored ? Number(stored) : heureFinInitiale();
    });

    const [remainingTime, setRemainingTime] = useState(
        Math.max(0, Math.floor((heureFin - Date.now()) / 1000))
    );

    const [pauseStartTime, setPauseStartTime] = useState(null);
    const [totalPausedTime, setTotalPausedTime] = useState(0);
    const [pauseRemainingTime, setPauseRemainingTime] = useState(null);

    useEffect(() => {
        localStorage.setItem('heureFinExamen', heureFin);
    }, [heureFin]);

    const timerRef = useRef(null);

    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Fonction pour rendre les questions par correspondance
    const renderCorrespondanceQuestion = (qcm, currentQcmIndex) => {
        try {
            let leftOptions = [];
            let rightOptions = [];
            let pairs = {};

            if (typeof qcm.option1 === 'string') {
                try {
                    leftOptions = JSON.parse(qcm.option1);
                    if (!Array.isArray(leftOptions)) {
                        leftOptions = [];
                    }
                } catch (e) {
                    console.error('Erreur parsing option1:', e);
                    leftOptions = [];
                }
            } else if (Array.isArray(qcm.option1)) {
                leftOptions = qcm.option1;
            }

            if (typeof qcm.option2 === 'string') {
                try {
                    rightOptions = JSON.parse(qcm.option2);
                    if (!Array.isArray(rightOptions)) {
                        rightOptions = [];
                    }
                } catch (e) {
                    console.error('Erreur parsing option2:', e);
                    rightOptions = [];
                }
            } else if (Array.isArray(qcm.option2)) {
                rightOptions = qcm.option2;
            }

            pairs = qcm.reponse || {};

            const savedData = answers[qcm.ref] || {};
            const currentPairs = savedData.pairs || {};

            const handleCorrespondanceChange = (leftId, rightId) => {
                const newPairs = { ...currentPairs };
                if (!rightId) {
                    delete newPairs[leftId];
                } else {
                    newPairs[leftId] = Number(rightId);
                }

                const updatedAnswers = {
                    ...answers,
                    [qcm.ref]: {
                        type: 'correspondance',
                        pairs: newPairs
                    }
                };
                setAnswers(updatedAnswers);
                localStorage.setItem('answers', JSON.stringify(updatedAnswers));

                const previousAnswersRecap = JSON.parse(localStorage.getItem('answersRecap')) || {};
                const newAnswersRecap = {
                    ...previousAnswersRecap,
                    [qcm.ref]: {
                        answers: newPairs,
                        index: currentQcmIndex,
                    }
                };
                localStorage.setItem('answersRecap', JSON.stringify(newAnswersRecap));
            };

            if (!leftOptions || leftOptions.length === 0) {
                return <div className="text-danger">Aucun item à associer trouvé</div>;
            }

            if (!rightOptions || rightOptions.length === 0) {
                return <div className="text-danger">Aucune correspondance trouvée</div>;
            }

            return (
                <>
                    <style>{`
                    .correspondance-table {
                        width: 100%;
                        background: #f8f9fa;
                        border-radius: 5px;
                        border: 1px solid #e9ecef;
                        padding: 10px;
                        margin-top: 10px;
                    }
                    .correspondance-table td {
                        padding: 6px 10px;
                        vertical-align: middle;
                        border-bottom: 1px solid #e9ecef;
                        text-align: left !important;
                    }
                    .correspondance-table tr:last-child td {
                        border-bottom: none;
                    }
                    .correspondance-table .title-row td {
                        font-weight: 600;
                        font-size: 14px;
                        
                        border-bottom: 2px solid #dee2e6;
                        padding-bottom: 10px;
                    }
                    .correspondance-table select {
                        font-size: 13px;
                        height: 32px;
                        width: 60px;
                        min-width: 60px;
                        border-radius: 4px;
                        border: 1px solid #ced4da;
                        padding: 2px 4px;
                        margin-right: 10px;
                        display: inline-block;
                    }
                    .correspondance-table .item-text {
                        font-size: 13px;
                        font-weight: 500;
                        display: inline-block;
                    }
                    .correspondance-table .numero {
                        font-size: 13px;
                        font-weight: 600;
                        margin-right: 5px;
                        display: inline-block;
                        min-width: 25px;
                    }
                    .correspondance-table .info-text {
                        margin-top: 10px;
                        font-size: 12px;
                        text-align: center;
                        color: #6c757d;
                    }
                    .correspondance-table .left-cell {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                    }
                    .correspondance-table .right-cell {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                    }
                `}</style>

                    <table className="correspondance-table">
                        <thead>
                            <tr className="title-row">
                                <td style={{ width: '50%' }}>
                                    {langue === 'Fr' ? 'Items à associer' : 'Items to match'}
                                </td>
                                <td style={{ width: '50%' }}>
                                    {langue === 'Fr' ? 'Correspondances' : 'Correspondences'}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {leftOptions.map((leftItem, index) => {
                                const currentPair = currentPairs[leftItem.id] || '';
                                let selectedIndex = '';
                                if (currentPair) {
                                    const foundIndex = rightOptions.findIndex(item => item.id === currentPair);
                                    if (foundIndex !== -1) {
                                        selectedIndex = foundIndex + 1;
                                    }
                                }
                                const rightItem = rightOptions[index] || {};
                                const numero = index + 1;
                                return (
                                    <tr key={leftItem.id || index}>
                                        <td>
                                            <div className="left-cell">
                                                <select
                                                    value={selectedIndex}
                                                    onChange={(e) => {
                                                        const selectedValue = e.target.value;
                                                        if (selectedValue === '') {
                                                            handleCorrespondanceChange(leftItem.id, '');
                                                        } else {
                                                            const rightId = rightOptions[parseInt(selectedValue) - 1]?.id;
                                                            if (rightId) {
                                                                handleCorrespondanceChange(leftItem.id, rightId);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <option value="">-</option>
                                                    {rightOptions.map((item, idx) => (
                                                        <option key={item.id} value={idx + 1}>
                                                            {idx + 1}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span className="item-text">{leftItem.value || `Item ${index + 1}`}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="right-cell">
                                                <span className="numero">{numero}.</span>
                                                <span className="item-text">{rightItem.value || `Correspondance ${rightItem.id}`}</span>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                </>
            );
        } catch (e) {
            console.error('Erreur rendu correspondance:', e);
            return <div className="text-danger">Erreur d'affichage des correspondances: {e.message}</div>;
        }
    };


    const [pausedAtTimes, setPausedAtTimes] = useState(new Set());
    useEffect(() => {
        if (isEssai) {
            setRemainingTime(null);
            return;
        }
        const startTimeKey = "examStartTime";
        const savedStartTime = localStorage.getItem(startTimeKey);
        const startTime = savedStartTime ? parseInt(savedStartTime, 10) : Date.now();

        if (!savedStartTime) {
            localStorage.setItem(startTimeKey, startTime);
        }

        const totalTimeInSeconds = nbre_heures * 60 * 60;
        const oneThirdTimeInSeconds = totalTimeInSeconds / 3;

        const updateTimer = () => {
            if (isPaused) return;

            const now = Date.now();
            const isExamOver = now >= heureFin;

            if (isExamOver) {
                clearInterval(timerRef.current);
                handleFinishExamen();
                return;
            }

            const newRemaining = Math.floor((heureFin - now) / 1000);
            setRemainingTime(newRemaining);

            if (pauseChoice === "avecPause") {
                const elapsedActiveTime = Math.floor((now - startTime - totalPausedTime) / 1000);
                const oneThird = (nbre_heures * 3600) / 3;

                if (elapsedActiveTime > 0 &&
                    elapsedActiveTime % oneThird < 1 &&
                    !pausedAtTimes.has(Math.floor(elapsedActiveTime / oneThird))) {

                    handleShowPauseModal();
                    setPausedAtTimes(prev => new Set(prev).add(Math.floor(elapsedActiveTime / oneThird)));
                }
            }
        };

        if (!isPaused) {
            updateTimer();
            timerRef.current = setInterval(updateTimer, 1000);
        }

        return () => {
            clearInterval(timerRef.current);
        };
    }, [isPaused, totalPausedTime, pausedAtTimes, isEssai]);

    const togglePause = () => {
        if (isEssai) return;

        setIsPaused(prev => {
            if (!prev) {
                const pauseStart = Date.now();
                setPauseStartTime(pauseStart);
                localStorage.setItem('pauseStartTime', pauseStart.toString());
                localStorage.setItem('isPaused', 'true');
                localStorage.setItem('remainingTimeBeforePause', remainingTime.toString());
                navigate('/Recapitulatif-examen', {
                    state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
                });
            } else {
                const pauseEnd = Date.now();
                const pauseDuration = Math.min(pauseEnd - pauseStartTime, 10 * 60 * 1000);
                setTotalPausedTime(prev => prev + pauseDuration);
            }
            return !prev;
        });
    };

    useEffect(() => {
        const savedPauseStartTime = localStorage.getItem('pauseStartTime');
        const savedIsPaused = localStorage.getItem('isPaused');

        if (savedIsPaused === 'true' && savedPauseStartTime) {
            const pauseStart = Number(savedPauseStartTime);
            const pauseDuration = Date.now() - pauseStart;

            if (pauseDuration < 10 * 60 * 1000) {
                setIsPaused(true);
                setPauseStartTime(pauseStart);
                setPauseRemainingTime(10 * 60 * 1000 - pauseDuration);
            } else {
                localStorage.removeItem('pauseStartTime');
                localStorage.setItem('isPaused', 'false');
            }
        }
    }, []);

    useEffect(() => {
        if (isPaused && pauseStartTime) {
            const intervalId = setInterval(() => {
                const pauseDuration = Date.now() - pauseStartTime;
                const remainingTime = Math.max(10 * 60 * 1000 - pauseDuration, 0);

                setPauseRemainingTime(remainingTime);

                if (remainingTime <= 0) {
                    togglePause();
                }
            }, 1000);

            return () => clearInterval(intervalId);
        }
    }, [isPaused, pauseStartTime]);

    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const formatDateTime = (date) => {
        return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    const examEndTime = heureFin ? new Date(heureFin) : null;

    const parseDate = (dateString, isISO) => {
        let date;
        if (isISO) {
            date = new Date(dateString);
        } else {
            date = new Date(parseInt(dateString, 10));
        }
        return date.toLocaleString("fr-FR", {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).replace(',', '');
    };

    useEffect(() => {
        const savedAnswers = localStorage.getItem('answers');
        if (savedAnswers) {
            setAnswers(JSON.parse(savedAnswers));
        }
    }, []);

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            resetFeedbackState();
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            resetFeedbackState();
        }
    };

    const resetFeedbackState = () => {
        setExplanationVisible(false);
        setFeedbackVisible(false);
        setIsAnswerCorrect(null);
    };

    const [isLoadingBouton, setIsLoadingBouton] = useState(false);

    const handleFinishExamen = async () => {
        setIsLoadingBouton(true);
        try {
            const savedAnswers = localStorage.getItem('answers');
            const answersToSend = savedAnswers ? JSON.parse(savedAnswers) : {};

            console.log("Réponses envoyées :", answersToSend);

            await fetch(`${process.env.REACT_APP_HOTE}/sauvegarder-reponse-qcm-refonte/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    answers: answersToSend,
                    user_id: user_id,
                    nbre_heures: nbre_heures,
                    examen_id: examen_id,
                }),
            });

            await fetch(`${process.env.REACT_APP_HOTE}/resultats-examenblanc-refonte/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: user_id,
                    examen_id: examen_id,
                }),
            });

            localStorage.removeItem('heureDebutExamen');
            localStorage.removeItem('heureFinExamen');
            localStorage.removeItem('answers');
            localStorage.removeItem('currentQcmIndex');
            localStorage.removeItem('examen_id_strored');
            localStorage.removeItem('answersRecap');
            localStorage.removeItem('isPaused');
            localStorage.removeItem('examStartTime');
            localStorage.removeItem('examPauseTime');
            localStorage.removeItem('totalPausedTime');
            localStorage.removeItem('pauseStartTime');
            localStorage.removeItem('totalPausedTime');
            localStorage.removeItem('remainingTimeBeforePause');

            navigate('/Fin-examen', { state: { examen_id, user_id }, replace: true });
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingBouton(false);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: '', type: '' }), 5000);
    };

    useEffect(() => {
        if (qcms.length > 0) {
            localStorage.setItem('currentQcmIndex', currentQcmIndex);
        }
    }, [currentQcmIndex, qcms]);

    const fetchExamens = async () => {
        setIsLoading(true);
        try {
            const heureDebutExamen = localStorage.getItem('heureDebutExamen');
            const heureFinExamen = localStorage.getItem('heureFinExamen');

            const isISODateDebut = isNaN(heureDebutExamen);
            const isISODateFin = isNaN(heureFinExamen);

            const heureDebutFormatee = parseDate(heureDebutExamen, isISODateDebut);
            const heureFinFormatee = parseDate(heureFinExamen, isISODateFin);

            let url;
            if (isEssai) {
                url = `${process.env.REACT_APP_HOTE}/charger-qcms-essai/${user_id}/${examen_id}/`;
            } else {
                url = `${process.env.REACT_APP_HOTE}/charger-qcms-examenblanc/${user_id}/${nbre_heures}/${examen_id}/?heureDebut=${encodeURIComponent(heureDebutFormatee)}&heureFin=${encodeURIComponent(heureFinFormatee)}`;
            }

            const response = await fetch(url);
            const data = await response.json();
            if (response.ok) {
                setIsLoading(false);
                localStorage.setItem('examen_id_strored', examen_id);
                setQcms(data.qcms);
                setLangue(data.langue);

                const savedStep = localStorage.getItem('currentQcmIndex');
                if (savedStep) {
                    const step = Number(savedStep);
                    if (step >= 0 && step < data.qcms.length) {
                        setCurrentQcmIndex(step);
                    } else {
                        setCurrentQcmIndex(0);
                    }
                }
            } else {
                setIsLoading(false);
                showAlert('Erreur lors de la récupération des QCMs' + data.error, 'danger');
            }
        } catch (error) {
            setIsLoading(false);
            showAlert('Erreur réseau', 'error');
        }
    };

    useEffect(() => {
        fetchExamens();
    }, [user_id, examen_id]);

    const handleModifierLangue = async () => {
        const nouvelleLangue = langue === "Fr" ? "Ang" : "Fr";
        setLangue(nouvelleLangue);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-langue-examenblanc/${examen_id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ langue: nouvelleLangue })
            });

            const data = await response.json();
            if (response.ok) {
                fetchExamens();
            } else {
                const errorData = await response.json();
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
        }
    };

    const [formattedAnswers, setFormattedAnswers] = useState(null);

    const handleMultipleAnswerChange = (qcmId, option, isChecked, currentQcmIndex) => {
        const qcm = qcms.find(q => q.ref === qcmId);
        if (qcm?.type_question === 'correspondance') {
            return;
        }

        setAnswers(prevAnswers => {
            const isMultipleChoice = qcms.find(qcm => qcm.ref === qcmId)?.reponse.length > 1;

            let newAnswers;
            let newAnswersRecap;

            const previousAnswersRecap = JSON.parse(localStorage.getItem('answersRecap')) || {};

            if (isMultipleChoice) {
                const currentAnswers = prevAnswers[qcmId] || [];
                const updatedAnswers = isChecked
                    ? [...currentAnswers, option]
                    : currentAnswers.filter(answer => answer !== option);

                newAnswers = {
                    ...prevAnswers,
                    [qcmId]: updatedAnswers,
                };

                newAnswersRecap = {
                    ...previousAnswersRecap,
                    [qcmId]: {
                        answers: updatedAnswers,
                        index: currentQcmIndex,
                    }
                };
            } else {
                newAnswers = {
                    ...prevAnswers,
                    [qcmId]: isChecked ? [option] : [],
                };

                newAnswersRecap = {
                    ...previousAnswersRecap,
                    [qcmId]: {
                        answers: isChecked ? [option] : [],
                        index: currentQcmIndex,
                    },
                };
            }

            const formattedData = Object.entries(newAnswersRecap).map(([qcmId, data]) => ({
                id: qcmId,
                answers: data.answers,
                index: data.index
            }));

            localStorage.setItem('answers', JSON.stringify(newAnswers));
            localStorage.setItem('answersRecap', JSON.stringify(newAnswersRecap));
            setFormattedAnswers(formattedData);

            return newAnswers;
        });
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row justify-content-between'>
                                <div className=' ml-2 row align-items-end'>
                                    <h2>
                                        <FaNewspaper size={25} className='mr-2' />
                                        {isEssai ? 'Essai' : 'Examen blanc'}

                                    </h2>
                                    <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer', marginBottom: '10px' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span>
                                </div>
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                {langue === 'Fr' ? (
                                    <small>
                                        <b>Légende des icônes : </b>
                                        <FaEye className="ivt-align-menu" /> indique que la question a été déjà vue.
                                        <br />
                                        Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer une simulation.
                                        Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                        Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                    </small>
                                ) : (
                                    <small>
                                        For each MCQ, only one answer is possible. Check the correct answer. Use the buttons for better management of the MCQ.
                                        <br />
                                        <b>Legend of icons: </b>
                                        <FaEye className="ivt-align-menu" /> indicates that the question has already been seen.
                                        <br />
                                        The <FaTimesCircle className="ivt-align-menu" /> button allows you to finish a simulation.
                                        The <FaArrowLeft className="ivt-align-menu" /> button allows you to go to the previous question.
                                        The <FaArrowRight className="ivt-align-menu" /> button allows you to go to the next question.
                                    </small>
                                )}
                            </div>
                            <div className='row ml-3'>
                                <div className={`row timer ${remainingTime <= 600 ? 'text-danger' : ''}`}>
                                    {isEssai ? (
                                        <div>
                                            {/* <span>⏳ Essai </span> */}
                                        </div>
                                    ) : (
                                        <>
                                            {isPaused && pauseRemainingTime !== null ? (
                                                <p>
                                                    ⏳ Pause en cours : {Math.floor(pauseRemainingTime / 60000)} min {Math.ceil((pauseRemainingTime % 60000) / 1000)} sec restantes
                                                </p>
                                            ) : (
                                                <>
                                                    {examEndTime && (
                                                        <span> Fin à : {formatDateTime(examEndTime)} - </span>
                                                    )}
                                                    Temps restant: {formatTime(remainingTime)}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                                {!isEssai && <StatutInternet />}

                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <td className='d-flex'>
                                                <div >
                                                    <td className='badge badge-secondary'> {qcms[currentQcmIndex]?.ref} </td>
                                                    <td>
                                                        {qcms[currentQcmIndex]?.deja_vu === "oui" && (
                                                            <i className="ml-1 fa fa-eye" title="Déjà vu"></i>
                                                        )}
                                                    </td>
                                                </div>
                                                <div className="btn-group ml-2" style={{ width: '100px' }} >
                                                    <button
                                                        onClick={handleModifierLangue}
                                                        className={`btn btn-xs ${langue === 'Fr' ? 'btn-success' : ''}`}
                                                        disabled={langue === 'Fr'}
                                                    >
                                                        FR
                                                    </button>
                                                    <button
                                                        onClick={handleModifierLangue}
                                                        className={`btn btn-xs ${langue !== 'Fr' ? 'btn-success' : ''}`}
                                                        disabled={langue === 'Ang'}
                                                    >
                                                        EN
                                                    </button>
                                                </div>
                                            </td>

                                            <td>
                                                {qcms.length > 0
                                                    ? `${currentQcmIndex + 1} ${langue === 'Fr' ? 'sur' : 'sur '} ${qcms.length}`
                                                    : "0 sur 0"}
                                            </td>

                                            <td className='d-flex'>
                                                <button
                                                    className="btn btn-outline btn-secondary btn-sm mr-2"
                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                    title="Personnaliser les couleurs"
                                                >
                                                    <i className="fa fa-paint-brush"></i>
                                                </button>

                                                {showColorPicker && (
                                                    <div className="color-palette" style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        right: '10',
                                                        zIndex: 1000,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '5px',
                                                        padding: '10px',
                                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                        width: '250px'
                                                    }}>
                                                        <div className="mb-2">
                                                            <label className="small">Couleur du texte:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={textColor}
                                                                onChange={(e) => setTextColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="small">Couleur de fond:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={bgColor}
                                                                onChange={(e) => setBgColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mt-2 text-right">
                                                            <button
                                                                className="btn btn-sm btn-secondary mr-2"
                                                                onClick={() => {
                                                                    setShowColorPicker(false);
                                                                }}
                                                            >
                                                                Fermer
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() => {
                                                                    setTextColor('#000000');
                                                                    setBgColor('#ffffff');
                                                                    setOptionColors({});
                                                                }}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="mr-2 d-flex">
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${currentSize + 1}px`;
                                                            });
                                                        }}
                                                        title="Zoomer"
                                                    >
                                                        <i className="fa fa-search-plus"></i>
                                                    </Button>
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm ml-1"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${Math.max(12, currentSize - 1)}px`;
                                                            });
                                                        }}
                                                        title="Dézoomer"
                                                    >
                                                        <i className="fa fa-search-minus"></i>
                                                    </Button>
                                                </div>
                                                {accesGroupe.includes("Administration") &&
                                                    <Button className='mr-2' onClick={() => setShowModal(true)}>
                                                        <FaEdit />
                                                        {showModal && currentQcmIndex !== null && (
                                                            <QuestionModal
                                                                show={showModal}
                                                                handleClose={handleCloseModal}
                                                                qcm_ref={qcms[currentQcmIndex]?.unicite}
                                                                user_id={user_id}
                                                                reussite={fetchExamens}
                                                            />
                                                        )}
                                                    </Button>
                                                }

                                                {!isEssai &&
                                                    <button className="btn btn-outline btn-success mr-2"
                                                        onClick={() => navigate('/Recapitulatif-examen', {
                                                            state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
                                                        })}>
                                                        <i className="fa fa-check mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            <small>Recapitulatif</small>
                                                        </span>
                                                    </button>
                                                }


                                                {isLoadingBouton ? (
                                                    <button className="btn btn-success mr-2" disabled>
                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            {langue === 'Fr' ? 'Chargement...' : 'Loading...'}
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success" onClick={() => setShowConfirmationModal(true)}>
                                                        <i className="fa fa-times-circle mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            <small> Terminer l'{isEssai ? 'essai' : 'examen'} </small>
                                                        </span>
                                                    </button>
                                                )}
                                            </td>

                                        </tr>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content" style={{
                                            backgroundColor: bgColor,
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />
                                                    
                                                    {/* Affichage de la question */}
                                                    <div className=''>
                                                        <span
                                                            id="question"
                                                            style={{
                                                                fontSize: '12px',
                                                                color: textColor
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}
                                                        ></span>
                                                    </div>

                                                    {/* === BOUTON CONSULTER L'ÉTUDE DE CAS === */}
                                                    {qcms[currentQcmIndex]?.situation && (
                                                        <div className="mt-2 mb-3">
                                                            <Button 
                                                                variant="outline-primary" 
                                                                className="btn btn-success"
                                                                onClick={() => handleOpenSituation(qcms[currentQcmIndex].situation)}
                                                                style={{
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    padding: '6px 16px',
                                                                    fontSize: '13px'
                                                                }}
                                                            >
                                                                <i className="fa fa-file-text-o"></i>
                                                                {langue === 'Fr' ? 'Consulter l\'étude de cas' : 'View case study'}
                                                            </Button>
                                                        </div>
                                                    )}

                                                    {/* Affichage selon le type de question */}
                                                    {qcms[currentQcmIndex]?.type_question === 'correspondance' ? (
                                                        renderCorrespondanceQuestion(qcms[currentQcmIndex], currentQcmIndex)
                                                    ) : (
                                                        <div style={{ margin: '10px 10px' }}>
                                                            {Object.keys(qcms[currentQcmIndex])
                                                                .filter(key => key.startsWith('option') && qcms[currentQcmIndex][key] && (qcms[currentQcmIndex][key] !== 'non défini' && qcms[currentQcmIndex][key] !== 'vide'))
                                                                .map((key, index) => {
                                                                    const optionLetter = String.fromCharCode(65 + index);
                                                                    const isMultipleChoice = qcms[currentQcmIndex].reponse.length > 1;

                                                                    const currentAnswers = answers[qcms[currentQcmIndex].ref] || [];
                                                                    const isOptionChecked = currentAnswers.includes(optionLetter);
                                                                    const optionColor = optionColors[optionLetter] || textColor;

                                                                    return (
                                                                        <div className="checkbox" key={key} style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginBottom: '10px',
                                                                            backgroundColor: isOptionChecked ? 'rgba(0,123,255,0.1)' : 'transparent',
                                                                            padding: '5px',
                                                                            borderRadius: '5px'
                                                                        }}>
                                                                            <label style={{
                                                                                margin: 0,
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                                color: optionColor,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                width: '100%'
                                                                            }}>
                                                                                <input
                                                                                    type={isMultipleChoice ? "checkbox" : "radio"}
                                                                                    name={`qcmitem-${qcms[currentQcmIndex].ref}`}
                                                                                    value={optionLetter}
                                                                                    className="i-checks choix"
                                                                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                    onChange={(e) => handleMultipleAnswerChange(qcms[currentQcmIndex].ref, optionLetter, e.target.checked, currentQcmIndex)}
                                                                                    checked={isOptionChecked}
                                                                                />
                                                                                <span style={{ fontWeight: isOptionChecked ? 'bold' : 'normal', marginRight: '5px' }}>
                                                                                    {optionLetter} -
                                                                                </span>
                                                                                <span
                                                                                    id={`option${index + 1}`}
                                                                                    style={{
                                                                                        color: optionColor,
                                                                                        fontWeight: isOptionChecked ? 'bold' : 'normal'
                                                                                    }}
                                                                                >
                                                                                    {qcms[currentQcmIndex][key]}
                                                                                </span>

                                                                                {feedbackVisible &&
                                                                                    selectedAnswer?.qcmId === qcms[currentQcmIndex].ref &&
                                                                                    selectedAnswer.value.includes(optionLetter) &&
                                                                                    !explanationVisible && (
                                                                                        qcms[currentQcmIndex].reponse.includes(optionLetter) ? (
                                                                                            <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct"></i>
                                                                                        ) : (
                                                                                            <i className="fa fa-thumbs-o-down fa-2x ivt-align-menu" style={{ color: 'red', marginLeft: '5px' }} title="Incorrect"></i>
                                                                                        )
                                                                                    )}

                                                                                {explanationVisible &&
                                                                                    qcms[currentQcmIndex].reponse.includes(optionLetter) && (
                                                                                        <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer"></i>
                                                                                    )}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    )}

                                                    {explanationVisible && qcms[currentQcmIndex].explication != 'non défini' && (
                                                        <div className='d-flex' style={{ color: 'green' }}>
                                                            <div style={{ color: 'green' }}>
                                                                <span>Explication : </span>
                                                                <span dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex].explication }} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </form>
                                            ) : (
                                                <p>Aucun QCM trouvé pour cet examen.</p>
                                            )}
                                        </div>
                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    {
                                        !enLigne ? "" : (
                                            <div className="d-flex ibox-footer justify-content-end">

                                                {currentQcmIndex > 0 && !isPaused && (
                                                    <Button
                                                        onClick={handlePreviousQcm}
                                                        className="btn btn-outline btn-success d-flex align-items-center justify-content-center"
                                                        style={{ marginLeft: '10px', gap: '5px' }}
                                                    >
                                                        <FaArrowCircleLeft />
                                                        Précédent
                                                    </Button>
                                                )}
                                                {currentQcmIndex < qcms.length - 1 && !isPaused && (
                                                    <Button
                                                        onClick={handleNextQcm}
                                                        className="btn btn-outline btn-success d-flex align-items-center justify-content-center"
                                                        style={{ marginLeft: '10px', gap: '5px' }}
                                                    >
                                                        Suivant
                                                        <FaArrowCircleRight />
                                                    </Button>
                                                )}
                                            </div>
                                        )
                                    }
                                </div>

                                <Modal show={showPauseModal} onHide={handleClosePauseModal}>
                                    <Modal.Header>
                                        <Modal.Title>{langue === 'Fr' ? "Pause" : "Break"}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {langue === 'Fr'
                                            ? "Voulez-vous faire une pause de 10 minutes ?"
                                            : "Do you want to take a 10-minute break?"}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClosePauseModal}>
                                            {langue === 'Fr' ? "Non" : "No"}
                                        </Button>
                                        <Button variant="success" onClick={togglePause}>
                                            {langue === 'Fr' ? "Oui" : "Yes"}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
                                    <Modal.Header>
                                        <Modal.Title>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Voulez-vous réellement mettre fin à l'{isEssai ? 'essai' : 'examen'}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
                                            Annuler
                                        </Button>
                                        <Button variant="success" onClick={handleFinishExamen}>
                                            Terminer
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                {/* === MODAL POUR AFFICHER L'ÉTUDE DE CAS === */}
                                <Modal 
                                    show={showSituationModal} 
                                    onHide={handleCloseSituationModal}
                                    size="lg"
                                    centered
                                >
                                    
                                    <Modal.Body>
                                        <div 
                                            style={{
                                                maxHeight: '60vh',
                                                overflowY: 'auto',
                                                padding: '15px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                lineHeight: '1.8',
                                                fontSize: '14px'
                                            }}
                                        >
                                            {langue === 'Fr' ? (
                                                <div 
                                                    dangerouslySetInnerHTML={{ 
                                                        __html: selectedSituation?.description || 'Aucune description disponible pour cette étude de cas.' 
                                                    }} 
                                                />
                                            ) : (
                                                <div 
                                                    dangerouslySetInnerHTML={{ 
                                                        __html: selectedSituation?.description_en || 'No description available for this case study.' 
                                                    }} 
                                                />
                                            )}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseSituationModal}>
                                            {langue === 'Fr' ? 'Fermer' : 'Close'}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demarrer_examen_refonte;